/**
 * TableToExcel组件demo
 * @description TableToExcel组件demo
 * @author wuTao
 * @date 2020-10-13
 */
import React from 'react';
import ReactDOM from 'react-dom'
import {connect} from 'dva';

import {component_tool, framework_tool} from '@/tool'

let {WizCard, WizTable,WizHtmlTableToExce,WizButton} = component_tool;
let {WizContainer} = framework_tool;
const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: 100,
  },
  {
    title: 'Other',
    children: [
      {
        title: 'Age',
        dataIndex: 'age',
        key: 'age',
        width: 150
      },
      {
        title: 'Address',
        children: [
          {
            title: 'Street',
            dataIndex: 'street',
            key: 'street',
            width: 150,
          },
          {
            title: 'Block',
            children: [
              {
                title: 'Building',
                dataIndex: 'building',
                key: 'building',
                width: 100,
              },
              {
                title: 'Door No.',
                dataIndex: 'number',
                key: 'number',
                width: 100,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: 'Company',
    children: [
      {
        title: 'Company Address',
        dataIndex: 'companyAddress',
        key: 'companyAddress',
        width: 200,
      },
      {
        title: 'Company Name',
        dataIndex: 'companyName',
        key: 'companyName',
      },
    ],
  },
  {
    title: 'Gender',
    dataIndex: 'gender',
    key: 'gender',
    width: 80,
  },
];
const data = [];
for (let i = 0; i < 5; i++) {
  data.push({
    key: i,
    name: 'John Brown',
    age: i + 1,
    street: 'Lake Park',
    building: 'C',
    number: 2035,
    companyAddress: 'Lake Street 42',
    companyName: 'SoftLake Co',
    gender: 'M',
  });
}

class TableToExcel extends WizContainer {

  componentName = 'TableToExcel';

  componentDidMount() {
    //利用reactdom.finddomnode()来获取真实DOM节点
    const tableCon1 = ReactDOM.findDOMNode(this.refs['table1']);
    const table1 = tableCon1.querySelector('table');
    //为table设置id属性
    table1.setAttribute('id', 'table-to-xls')
    const tableCon2 = ReactDOM.findDOMNode(this.refs['table2']);
    const table2 = tableCon2.querySelector('table');
    //为table设置id属性
    table2.setAttribute('id', 'table-to-xls')
  }


  _render() {
    return (
      <WizCard title="表格直接下载Excel" icon='0'>
        <WizButton.WizGroup>
          <WizHtmlTableToExce
            className="ant-btn"
            table="table-to-xls"
            filename="参训统计"
            sheet="参训统计"
            buttonText="导出参训统计"/>
          <> 报表更新日期： {'2020-10-16 22:33:33'}</>
        </WizButton.WizGroup>
        {/*<WizTable columns={columns}*/}
        {/*          dataSource={data}*/}
        {/*          bordered*/}
        {/*          pagination={false}*/}
        {/*          size="middle"*/}
        {/*          expandedRowRender={expandedRowRender}*/}
        {/*/>*/}
        <div>
          <WizTable ref='table1'
                    columns={columns}
                    dataSource={data}
                    bordered
                    pagination={false}
                    size="middle"
          />
          <WizTable ref='table2'
                    columns={columns}
                    dataSource={data}
                    bordered
                    pagination={false}
                    size="middle"
          />
        </div>
      </WizCard>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {};
};

export default connect(mapStateToProps)(TableToExcel);
